import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=2501b6d0&"
var script = {}
import style0 from "./buttons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports